const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const trackingUtils = require('od-modules/utils/tracking.utils');

module.exports = withRenderedMain(BaseView.extend({
    selectors: {
        welcomeMessage: '.welcome_message',
    },

    events: {
        'tap .help_centre_link': 'onHelpCentreLinkClick',
    },

    SUCCESS_TAG: 'create_pwd_success_pag',

    initialize(options) {
        BaseView.prototype.initialize.call(this, options);
        this.listenTo(this.model, 'change:name', this.renderWelcomeMessage);
        this.listenTo(this.model, 'change:email', this.renderPasswordSetup);
        this.loadToken();
    },

    loadToken() {
        const fragments = Odigeo.History.getFragment().split('/');
        const passwordToken = fragments.pop();
        if (passwordToken) {
            const infoToken = fragments.pop();
            if (infoToken) {
                Odigeo.trigger(`${this.id}:getTokenInfo`, infoToken);
            }
            this.model.set('passwordToken', passwordToken);
        }
    },

    renderWelcomeMessage() {
        const name = this.model.get('name');
        const title = Odigeo.Utils.replaceCmsKeyArgs(this.keys.title, name);
        this.$el.find(this.selectors.welcomeMessage).text(title);
    },

    renderPasswordSetup() {
        const email = this.model.get('email');
        const hashCode = this.model.get('passwordToken');

        Odigeo.trigger(`${this.id}:renderPasswordSetup`, {email, hashCode});
    },

    onHelpCentreLinkClick() {
        this.track('help_centre', 'help_centre_clicks_pag');
    },

    track(action, tag) {
        this.trackEvent(action, tag);

        if (tag === this.SUCCESS_TAG) {
            this.model.set('trackingCategory', 'prime_onboarding_ok');
            this.model.set('trackingLabelSuffix', 'prime-onb-ok');
            this.trackSuccessPage();
        }
    },

    trackEvent(action, tag) {
        const category = this.model.get('trackingCategory');
        const suffix = this.model.get('trackingLabelSuffix');
        const label = `${tag}:${suffix}`;

        trackingUtils.trackEventWithCategory(category, action, label);
    },

    trackSuccessPage() {
        trackingUtils.trackPage('prime/onboarding-password-ok', {funnel: false});
    },

}));
